if (!customElements.get('om-mobile-menu')) {
  customElements.define('om-mobile-menu', class extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-menu-category]')];
      this.panels = [...this.querySelectorAll('[data-menu-panel]')];
      this.drawer = this.closest('[data-drawer="hamburger"]');
      this.onOpen = () => {
        this.select(this.dataset.defaultCategory || 'men');
        this.drawer.querySelector('[data-drawer-scrolls]').scrollTop = 0;
      };
      this.onClick = event => {
        const tab = event.target.closest('[data-menu-category]');
        if (tab) this.select(tab.dataset.menuCategory);
      };
      this.onKeyDown = event => {
        const tab = event.target.closest('[data-menu-category]');
        if (!tab) return;
        const current = this.tabs.indexOf(tab);
        let index;
        if (event.key === 'ArrowRight') index = (current + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') index = (current - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') index = 0;
        if (event.key === 'End') index = this.tabs.length - 1;
        if (index === undefined) return;
        event.preventDefault();
        this.select(this.tabs[index].dataset.menuCategory);
        this.tabs[index].focus();
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKeyDown);
      this.drawer.addEventListener('theme:drawer:open', this.onOpen);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKeyDown);
      this.drawer.removeEventListener('theme:drawer:open', this.onOpen);
    }

    select(category) {
      this.tabs.forEach(tab => {
        const selected = tab.dataset.menuCategory === category;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
      });
      this.panels.forEach(panel => {
        const inactive = panel.dataset.menuPanel !== category;
        panel.hidden = inactive;
        panel.inert = inactive;
      });
    }
  });
}
